import React, { useEffect } from 'react';
import authTokenUtil from '../account/authTokenUtil';
import LoadingIndicator from '../components/LoadingIndicator';
import { MESSAGE_EMBED_AUTH_TOKEN } from '../constants/messages';
import styles from './EmbedLoginView.module.scss';
import Logger from '../utils/Logger';

const EmbedLoginView = () => {
  useEffect(() => {
    if (!window.opener) {
      Logger.warn('In EmbedLoginView, no window.opener found');
      return;
    }

    window.opener.postMessage(
      { type: MESSAGE_EMBED_AUTH_TOKEN, token: authTokenUtil.get() },
      window.location.origin,
    );
  });

  return (
    <div className={styles.container}>
      <LoadingIndicator />
    </div>
  );
};

export default EmbedLoginView;
